<!-- eslint-disable max-len -->
<template>
  <div class="main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll">

    <div class="flex flex-wrap">
      <div class="w-full p-3">
        <div
          class="bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
        >
          <h5 class="font-bold uppercase text-gray-600"> Withdraw Request </h5>
        </div>
        <div class="overflow-y-auto" style="min-height: 400px">
          <div style="margin-bottom: 10px">
            <el-row class="px-5 py-2" >
              <el-col :span="2" class="flex flex-row mr-1" >
                Filter Date
              </el-col>
              <el-col :span="4" class="flex flex-row mr-5" >
                <VueRangeDatePicker :format="'YYYY-MM-DD'" :i18n="'EN'" @selected="onChangeDate">
                  <input type="text" name="datepicker" value="start date - end date" />
                </VueRangeDatePicker>
              </el-col>
            </el-row>
          </div>

          <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Actions" align="right" min-width="150px">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Approve" :position="'is-left'">
                    <button @click="submitApproved($event, scope.row)" class="p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'check']" />
                    </button>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Reject" :position="'is-left'">
                    <button @click="submitReject($event, scope.row)" class="p-2 w-8 rounded bg-red-700 hover:bg-red-800 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'times']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import VueRangeDatePicker from 'vue-rangedate-picker';
import moment from 'moment';

const displayingItems = 50;

export default {
  name: 'WithdrawRequestPage',
  data() {
    return {
      isLoading: false,
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'artist.name',
        label: 'Artist Name',
      }, {
        prop: 'artist.email',
        label: 'Email',
      }, {
        prop: 'request_amount',
        label: 'Request Amount',
      }, {
        prop: 'issue_date',
        label: 'Issue Date',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        sortby: 'id',
        sortorder: 'desc',
        start_date: '2021-01-19',
        end_date: '2021-10-19',
      },
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListWithdrawRequest(this.filter);
    // this.refineData();
  },
  computed: {
    ...mapGetters('FinanceModule', ['listWithdrawRequest']),
  },
  watch: {
    listWithdrawRequest: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listWithdrawRequest.data !== undefined) {
          this.data = this.listWithdrawRequest.data.data;
          this.total = this.listWithdrawRequest.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('FinanceModule', ['requestListWithdrawRequest', 'requestApproveReject']),
    async search() {
      await this.requestListWithdrawRequest(this.filter);
      // this.refineData();
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        start_date: '',
        end_date: '',
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListWithdrawRequest(this.filter);
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.start).format('YYYY-MM-DD'),
        end_date: moment(res.end).format('YYYY-MM-DD'),
      };
      await this.search();
    },
    async submitApproved(event, row) {
      const data = {
        id: row.id,
        approved: true,
      };
      const filter = this.filter;
      Vue.swal({
        title: 'Approve Request',
        text: `Are you sure to approve request from: ${row.artist.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestApproveReject({ data, filter });
          this.$swal('Approved', 'You successfully approve this request', 'success');
        }
      });
    },
    async submitReject(event, row) {
      const data = {
        id: row.id,
        approved: false,
      };
      const filter = this.filter;
      Vue.swal({
        title: 'Reject Request',
        text: `Are you sure to reject request from: ${row.artist.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestApproveReject({ data, filter });
          this.$swal('Rejected', 'You successfully reject this request', 'success');
        }
      });
    },
  },
  components: {
    VueCustomTooltip,
    VueRangeDatePicker,
  },
};
</script>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/WithdrawRequest.vue